<template>
  <div :class="uploader.isCard ? $style.card_uploader : $style.uploader">
    <p v-if="!uploader.isCard">{{ uploader.text }}</p>
    <van-uploader
      :after-read="afterRead"
      :before-read="beforeRead"
      accept="image/*"
      @delete="deleteImg"
      v-model="fileList"
      :max-count="uploader.count"
      :preview-image="uploader.isCard ? false : true"
    ></van-uploader>
    <slot></slot>
  </div>
</template>

<script>
import { upload } from "@/http/cms";
import { Uploader } from "vant";
import Compressor from "compressorjs";
export default {
  name: "uploader",
  props: {
    uploader: {
      type: Object,
      default: () => {
        return {
          count: 2,
          text: "上传图片",
          isCard: true,
          delete: true,
          img: ""
        };
      }
    }
  },
  components: {
    [Uploader.name]: Uploader
  },
  data() {
    return {
      fileList: (this.uploader.reqiure && this.$ls.get("fileList")) || [],
      fileCompressList: []
    };
  },
  methods: {
    /**
     * @description 上传图片
     * @param {object} file  - 图片信息
     */
    afterRead(file) {
      this.$Toast.loading({
        forbidClick: true,
        duration: 0
      });
      new Compressor(file.file, {
        width: 640,
        quality: 0.6,
        success: result => {
          this.$Toast.clear();
          const formData = new FormData();
          formData.append("filename", result, result.name);
          upload(formData).then(res => {
            if (!res.data) return;
            this.fileCompressList.push({
              lastModified: file.file.lastModified,
              fileName: res.data.url
            });
            //身份证识别需要加缓存
            if (this.uploader.isCard) {
              // 修复当图片过大时，部分机型无法进行 session 存储的问题
              // blob to base64
              const reader = new FileReader();
              reader.readAsDataURL(result);
              reader.onload = e => {
                this.$ls.set(
                  "fileList",
                  this.fileList.map(el => {
                    return { ...el, content: e.target.result };
                  })
                );
              };
              this.$emit(
                "identifyData",
                res.data.filepath,
                file.content,
                res.data.url
              );
            }
            this.updateImg();
          });
        },
        error(err) {
          this.$Toast(err.message);
        }
      });
    },
    /**
     * @description 限制图片格式
     * @param {object} file  - 图片信息
     */
    imgFormat(file) {
      if (!/image/g.test(file.type)) {
        this.$Toast("请上传图片格式的文件");
        return false;
      }
      return true;
    },
    /**
     * @description 上传图片之前
     * @param {object} file  - 图片信息
     */
    beforeRead(file) {
      return this.imgFormat(file);
    },
    /**
     * @description 删除图片
     * @param {object} file  - 图片信息
     */
    deleteImg(file) {
      this.fileCompressList = this.fileCompressList.filter(
        item => item.lastModified !== file.file.lastModified
      );
      this.updateImg();
    },
    /**
     * @description 清空图片
     */
    clearImg() {
      this.fileCompressList = [];
      this.fileList = [];
      if (this.uploader.isCard) {
        this.$ls.set("fileList" || []);
      }

      this.updateImg();
    },
    /**
     * @description  更新图片
     */
    updateImg() {
      let imgList = [];
      for (let item of this.fileCompressList.values()) {
        imgList.push(item.fileName);
      }
      this.$emit("update", imgList);
    }
  }
};
</script>

<style lang="less" module>
.uploader {
  .flex-row;
  padding: 0.4rem 0.1rem 0.4rem 0.5rem;

  p {
    font-size: 0.28rem;
    color: #222222;
    margin-right: 0.2rem;
  }
  :global {
    .van-uploader__upload {
      border: 0.02rem dashed #cac8ca;
    }
    .van-uploader__preview-delete {
      color: #ff4500;
    }
  }
}
</style>
